import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { router } from './routes';
import { useAuthStore } from './stores/authStore';
import { isMenuDomain } from './pwa';
import SiplyLanding from './pages/SiplyLanding';

function App() {
  const initializeAuth = useAuthStore((state) => state.initializeAuth);
  // siply.pro/ used to fall through to the protected dashboard route and land guests on
  // the staff login. Decided here rather than in the router so that every other path on
  // the menu domain keeps behaving exactly as before.
  const isGuestLanding = isMenuDomain() && window.location.pathname === '/';

  useEffect(() => {
    if (!isGuestLanding) initializeAuth();
  }, [initializeAuth, isGuestLanding]);

  if (isGuestLanding) {
    return <SiplyLanding />;
  }

  return (
    <>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'bg-dark-800 text-dark-100 border border-dark-700',
          duration: 4000,
          style: {
            background: '#1e293b',
            color: '#f1f5f9',
            border: '1px solid #334155',
          },
          success: {
            iconTheme: {
              primary: '#22c55e',
              secondary: '#0f172a',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#0f172a',
            },
          },
        }}
      />
    </>
  );
}

export default App;
